var React = require('react');

function EscalatorDownInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("path",{"d":"M49.913 42H55a6 6 0 1 1 0 12h-6.432a12 12 0 0 1-9.163-4.252l-22.263-26.33A4 4 0 0 0 14.087 22H9a6 6 0 1 1 0-12h6.432a12 12 0 0 1 9.163 4.252l22.263 26.33A4 4 0 0 0 49.913 42z","strokeLinecap":"square","key":0}),React.createElement("circle",{"strokeLinecap":"square","cx":"33","cy":"7","r":"3","key":1}),React.createElement("path",{"d":"M36 27.5V14a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v6.5M21 51L11 41","key":2}),React.createElement("path",{"strokeLinecap":"square","d":"M13 51h8v-8","key":3})]));
}

EscalatorDownInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = EscalatorDownInline;

EscalatorDownInline.default = EscalatorDownInline;
